export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14189.269d60a0.jpg";